// Header, phone menu, profile menu, footer and the language switcher.
// See messages/README.md for how to add strings.
export const nav = {
  en: {
    "nav.home": "Home",
    "nav.create": "Create",
    "nav.voices": "Voices",
    "nav.train": "Train a voice",
    "nav.library": "Library",
    "nav.tab.profile": "Profile",
    "nav.404.seoTitle": "Page Not Found | Jammable",
    "nav.404.title": "Page not found!",
    "nav.404.body": "Looks like this content no longer exists.",
    "nav.404.home": "Back Home",
    "nav.404.browse": "Browse voices",
    "nav.404.discordLabel": "Looking for something?",
    "nav.404.discordBody": "Ask the community on Discord",
    "nav.pricing": "Pricing",
    "nav.affiliate": "Affiliate Program",
    "nav.earn": "Earn 20%",
    "nav.api": "API",
    "nav.login": "Log in",
    "nav.signup": "Sign up",
    "nav.signupFree": "Sign up free",
    "nav.getPlan": "Get a plan",
    "nav.discordAria": "Join the Jammable Discord",
    "nav.discordJoin": "Join our Discord",
    "nav.openMenu": "Open menu",
    "nav.closeMenu": "Close menu",

    // Profile menu. Greetings are picked at random by time of day:
    // 0 morning, 1 afternoon, 2 evening, 3 late night; five of each.
    "nav.greet.0.0": "Hey, early riser",
    "nav.greet.0.1": "Morning",
    "nav.greet.0.2": "Sup",
    "nav.greet.0.3": "Hey there",
    "nav.greet.0.4": "What's up",
    "nav.greet.1.0": "Yo",
    "nav.greet.1.1": "Hey",
    "nav.greet.1.2": "Hi there",
    "nav.greet.1.3": "What's good",
    "nav.greet.1.4": "Howdy",
    "nav.greet.2.0": "Evening",
    "nav.greet.2.1": "Hey you",
    "nav.greet.2.2": "What's happening",
    "nav.greet.2.3": "Hi",
    "nav.greet.2.4": "Hiya",
    "nav.greet.3.0": "Still up?",
    "nav.greet.3.1": "Night owl, huh?",
    "nav.greet.3.2": "Yo, night person",
    "nav.greet.3.3": "Can't sleep?",
    "nav.greet.3.4": "Late night vibes",
    "nav.profile.view": "View profile",
    "nav.profile.credit": "Credit",
    "nav.profile.credits": "Credits",
    "nav.profile.voicePass": "Voice Pass",
    "nav.profile.voices": "Voices",
    "nav.profile.shop": "Item Shop",
    "nav.profile.feedback": "Give Feedback",
    "nav.profile.settings": "Settings",
    "nav.profile.apiDashboard": "API Dashboard",
    "nav.profile.signOut": "Sign out",
    "nav.profile.signedOut": "Signed out!",
    "nav.profile.avatarAlt": "user avatar",

    // Footer
    "nav.footer.tagline":
      "AI covers with 60,000+ voices. Make one in seconds.",
    "nav.footer.colCreate": "Create",
    "nav.footer.colAccount": "Account",
    "nav.footer.colLegal": "Legal",
    "nav.footer.aiCover": "AI Cover Generator",
    "nav.footer.voiceChanger": "AI Voice Changer",
    "nav.footer.voiceLibrary": "AI Voice Library",
    "nav.footer.train": "Train a Voice",
    "nav.footer.weights": "Weights AI Alternative",
    "nav.footer.settings": "Settings",
    "nav.footer.earn": "Earn with Jammable",
    "nav.footer.mcp": "MCP Server for AI Agents",
    "nav.footer.blog": "Guides",
    "nav.footer.compare": "Compare AI voice tools",
    "nav.footer.forgot": "Forgot password",
    "nav.footer.terms": "Terms of Use",
    "nav.footer.privacy": "Privacy Policy",
    "nav.footer.dmca": "DMCA Policy",
    "nav.footer.refunds": "Refund Policy",
    // "Uses <link>Pitchmeld technology</link> for voice processing"
    "nav.footer.pitchmeldBefore": "Uses",
    "nav.footer.pitchmeldLink": "Pitchmeld technology",
    "nav.footer.pitchmeldAfter": "for voice processing",

    "nav.language": "Language",
  },
};
